import { createStyles, Theme } from '@material-ui/core/styles';

const styles = ({ spacing, colors }: Theme) => createStyles({
  root: {
    zIndex: 0,
  },
  children: {
    marginRight: spacing(1),
  },
  arrowUp: {
    transform: 'rotate(180deg)',
  },
  popper: {
    top: ({ placement }: { placement: string }) => (
      placement === 'top' ? `-${spacing(1)}px !important` : `${spacing(1)}px !important`
    ),
    boxShadows: colors.pageElements.dropdownMenu.dropdownMenuShadow,
  },
});

export default styles;
